var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 0.5H1.5C1.1025 0.5 0.72075 0.65825 0.4395 0.9395C0.15825 1.22075 0 1.6025 0 2C0 4.36325 0 11.6368 0 14C0 14.3975 0.15825 14.7792 0.4395 15.0605C0.72075 15.3417 1.1025 15.5 1.5 15.5C3.86325 15.5 11.1368 15.5 13.5 15.5C13.8975 15.5 14.2792 15.3417 14.5605 15.0605C14.8417 14.7792 15 14.3975 15 14V2C15 1.6025 14.8417 1.22075 14.5605 0.9395C14.2792 0.65825 13.8975 0.5 13.5 0.5H10.125V6.5C10.125 6.749 10.0013 6.9815 9.79575 7.121C9.5895 7.2605 9.32775 7.289 9.09675 7.196L7.5 6.55775L5.90325 7.196C5.67225 7.289 5.4105 7.2605 5.20425 7.121C4.99875 6.9815 4.875 6.749 4.875 6.5V0.5ZM6.375 0.5H8.625V5.39225L7.77825 5.054C7.59975 4.982 7.40025 4.982 7.22175 5.054L6.375 5.39225V0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockblack);
export default __webpack_public_path__ + "static/media/stockblack.46f55ed3fd72b0db5f40f37d220593d8.svg";
export { ForwardRef as ReactComponent };